import { AuthenticationDetails, CognitoUserAttribute, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
const userPoolId = import.meta.env.VITE_PROSPECTOR_USER_POOL_ID as string | undefined;
const clientId = import.meta.env.VITE_PROSPECTOR_USER_POOL_CLIENT_ID as string | undefined;
function configuredPool() {
  if (!userPoolId || !clientId) throw new Error('Configure the isolated Prospector Cognito pool and client');
  return new CognitoUserPool({ UserPoolId: userPoolId, ClientId: clientId, Storage: sessionStorage });
}
export function signIn(email: string, password: string): Promise<string> {
  return new Promise((resolve, reject) => new CognitoUser({ Username: email, Pool: configuredPool() }).authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), { onSuccess: (session) => resolve(session.getIdToken().getJwtToken()), onFailure: reject, newPasswordRequired: () => reject(new Error('Complete the temporary-password change in Cognito before using Prospector')) }));
}
export function getSessionToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    const user = configuredPool().getCurrentUser();
    if (!user) { reject(new Error('Your session has expired. Please sign in again.')); return; }
    user.getSession((error: Error | null, session: { isValid(): boolean; getIdToken(): { getJwtToken(): string } }) => {
      if (error || !session?.isValid()) { reject(error ?? new Error('Your session has expired. Please sign in again.')); return; }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}
export function signOut() { if (userPoolId && clientId) configuredPool().getCurrentUser()?.signOut(); sessionStorage.removeItem('prospector_token'); sessionStorage.removeItem('prospector_session'); }

export function signUp(email: string, password: string): Promise<void> {
  return new Promise((resolve, reject) => configuredPool().signUp(email, password, [new CognitoUserAttribute({ Name: 'email', Value: email })], [], error => error ? reject(error) : resolve()));
}
export function confirmSignUp(email: string, code: string): Promise<void> {
  return new Promise((resolve, reject) => new CognitoUser({ Username: email, Pool: configuredPool() }).confirmRegistration(code, true, error => error ? reject(error) : resolve()));
}
export function resetPassword(email: string): Promise<void> {
  return new Promise((resolve, reject) => new CognitoUser({ Username: email, Pool: configuredPool() }).forgotPassword({ onSuccess: () => resolve(), onFailure: reject }));
}
export function confirmPassword(email: string, code: string, password: string): Promise<void> {
  return new Promise((resolve, reject) => new CognitoUser({ Username: email, Pool: configuredPool() }).confirmPassword(code, password, { onSuccess: () => resolve(), onFailure: reject }));
}
